import React from 'react';
import { AgCharts } from 'ag-charts-react';
import { IPortfolioLocationChartData } from '../../greenTypes';
import { AgChartOptions } from 'ag-charts-community';
import { ChartContainer } from '../../../../shared/components/charts/ChartContainer';

interface IPpClimateAlignmentChartProps {
	chartData: IPortfolioLocationChartData | undefined;
}

const PpClimateAlignmentChart: React.FC<IPpClimateAlignmentChartProps> = ({ ...props }) => {
	const data = props.chartData?.chartDataItemList || [];

	const options: AgChartOptions = {
		data: data,
		series: [
			{
				type: 'line',
				xKey: 'year',
				yKey: 'portfolioAer',
				yName: props.chartData?.expressions.portfolioAer,
				stroke: '#FFD700',
				strokeWidth: 2,
				lineDash: [4, 4], // Dashed line
				marker: {
					enabled: false,
				},
				tooltip: {
					renderer: (params: any) => {
						return { data: undefined, title: `Vessel AER(${params.datum.year}): ${params.datum.portfolioAer}` };
					},
				},
			},
			{
				type: 'line',
				xKey: 'year',
				yKey: 'ppTrajectoryMinimum',
				yName: props.chartData?.expressions.ppTrajectoryMinimum,
				stroke: '#00274D', // Dark Blue
				strokeWidth: 3,
				marker: {
					enabled: false,
				},
				tooltip: {
					renderer: (params: any) => {
						return { data: undefined, title: `PP Trajectory: Minimum: ${params.datum.ppTrajectoryMinimum}` };
					},
				},
			},
			{
				type: 'line',
				xKey: 'year',
				yKey: 'ppTrajectoryStriving',
				yName: props.chartData?.expressions.ppTrajectoryStriving,
				stroke: '#87CEFA', // Light Blue
				strokeWidth: 2,
				marker: {
					enabled: false,
				},
				tooltip: {
					renderer: (params: any) => {
						return { data: undefined, title: `PP Trajectory: Striving: ${params.datum.ppTrajectoryStriving}` };
					},
				},
			},
		],
		axes: [
			{
				type: 'number',
				position: 'left',
				title: {
					text: 'gCO₂/dwt.nm',
				},
			},
			{
				type: 'category',
				position: 'bottom',
				title: {
					text: 'Year',
				},
			},
		],
		legend: {
			position: 'bottom',
			item: {
				label: {
					fontSize: 12,
				},
				marker: {
					size: 12,
				},
			},
			spacing: 10,
		},
	};

	return (
		<ChartContainer
			data={options.data}
			filename="pp_climate_alignment_data"
			buttonPosition="top-right"
		>
			<AgCharts options={options} className="w-full h-full" />
		</ChartContainer>
	);
};

export default PpClimateAlignmentChart;
